import { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiError, setUnauthorizedHandler } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, object=auth
  const [booting, setBooting] = useState(true);

  // Any 401 from the API funnels through the canonical logout: clear the token
  // and let <Gate /> render the auth screen.
  useEffect(() => {
    setUnauthorizedHandler(() => {
      localStorage.removeItem("cadence_token");
      setUser(false);
    });
    return () => setUnauthorizedHandler(null);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("cadence_token");
    if (!token) { setUser(false); setBooting(false); return; }
    api.get("/auth/me")
      .then(({ data }) => setUser(data.user))
      .catch(() => { localStorage.removeItem("cadence_token"); setUser(false); })
      .finally(() => setBooting(false));
  }, []);

  async function login(email, password) {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("cadence_token", data.token);
    setUser(data.user);
  }
  async function register(email, password, name) {
    const { data } = await api.post("/auth/register", { email, password, name });
    localStorage.setItem("cadence_token", data.token);
    setUser(data.user);
  }
  function logout() {
    localStorage.removeItem("cadence_token");
    setUser(false);
  }

  return (
    <AuthContext.Provider value={{ user, booting, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export { formatApiError };
